/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AggregationMethodEnum } from "./AggregationMethodEnum";
import {
  AggregationMethodEnumFromJSON,
  AggregationMethodEnumFromJSONTyped,
  AggregationMethodEnumToJSON,
  AggregationMethodEnumToJSONTyped,
} from "./AggregationMethodEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedTwoDSubstanceConcentration
 */
export interface PatchedTwoDSubstanceConcentration {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  substance?: string;
  /**
   *
   */
  readonly substanceId?: number;
  /**
   *
   */
  readonly substanceName?: string;
  /**
   *
   */
  initialConcentration?: string;
  /**
   *
   */
  readonly initialConcentrationId?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  aggregationMethod?: AggregationMethodEnum;
}

/**
 * Check if a given object implements the PatchedTwoDSubstanceConcentration interface.
 */
export function instanceOfPatchedTwoDSubstanceConcentration(
  value: object
): value is PatchedTwoDSubstanceConcentration {
  return true;
}

export function PatchedTwoDSubstanceConcentrationFromJSON(
  json: any
): PatchedTwoDSubstanceConcentration {
  return PatchedTwoDSubstanceConcentrationFromJSONTyped(json, false);
}

export function PatchedTwoDSubstanceConcentrationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedTwoDSubstanceConcentration {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    substance: json["substance"] == null ? undefined : json["substance"],
    substanceId: json["substance_id"] == null ? undefined : json["substance_id"],
    substanceName: json["substance_name"] == null ? undefined : json["substance_name"],
    initialConcentration:
      json["initial_concentration"] == null ? undefined : json["initial_concentration"],
    initialConcentrationId:
      json["initial_concentration_id"] == null ? undefined : json["initial_concentration_id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
    aggregationMethod:
      json["aggregation_method"] == null
        ? undefined
        : AggregationMethodEnumFromJSON(json["aggregation_method"]),
  };
}

export function PatchedTwoDSubstanceConcentrationToJSON(
  json: any
): PatchedTwoDSubstanceConcentration {
  return PatchedTwoDSubstanceConcentrationToJSONTyped(json, false);
}

export function PatchedTwoDSubstanceConcentrationToJSONTyped(
  value?: Omit<
    PatchedTwoDSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    substance: value["substance"],
    initial_concentration: value["initialConcentration"],
    aggregation_method: AggregationMethodEnumToJSON(value["aggregationMethod"]),
  };
}
